/* eslint-disable @typescript-eslint/default-param-last */
import { GET_USER_IDENTITY } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IAuthActionType } from '../types/auth.types';

const authReducer = (state = initialState.auth, action: IAuthActionType) => {
  switch (action.type) {
    case `${GET_USER_IDENTITY}_SUCCESS`:
      return {
        ...state,
        userIdentityData: action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
